import {exhaustive} from '@freckle/exhaustive'

export type ValidatedT<A> =
  | {
      tag: 'empty'
    }
  | {
      tag: 'invalid'
      message: string
      previous: A | undefined | null
    }
  | {
      tag: 'valid'
      value: A
    }

export function empty<A>(): ValidatedT<A> {
  return {tag: 'empty'}
}

export function invalid<A>(message: string, previous?: A | null): ValidatedT<A> {
  return {tag: 'invalid', message, previous}
}

export function valid<A>(value: A): ValidatedT<A> {
  return {tag: 'valid', value}
}

export function extend<A>(message: string, previous: ValidatedT<A>): ValidatedT<A> {
  switch (previous.tag) {
    case 'empty':
      return invalid(message)
    case 'invalid':
      return invalid(message, previous.previous)
    case 'valid':
      return invalid(message, previous.value)
    default:
      return exhaustive(previous as never, 'ValidatedT')
  }
}

export function lastValidValue<A>(validated: ValidatedT<A>): A | undefined | null {
  switch (validated.tag) {
    case 'empty':
      return null
    case 'invalid':
      return validated.previous
    case 'valid':
      return validated.value
    default:
      return exhaustive(validated as never, 'ValidatedT')
  }
}

export function toMaybe<A>(validated: ValidatedT<A>): A | undefined | null {
  return validated.tag === 'valid' ? validated.value : null
}
